<template>
  <!-- <Sidebar v-if="!isPublicPage" /> -->

  <!-- <div class="d-flex flex-column w-100"> -->
  <!-- <Navbar v-if="!isPublicPage" /> -->
  <!-- <AutoLogout v-if="currentRouteName != 'Login' && loggedIn" /> -->

  <!-- <div id="main-content"> -->
  <router-view />
  <!-- </div> -->
  <!-- </div> -->
</template>

<script lang="ts" setup>
  // import Navbar from '@/components/Navbar.vue';
  // import Sidebar from '@/components/Sidebar.vue';
  // import AutoLogout from "@/components/AutoLogout.vue";
  // import LoadingSpinner from "@/components/LoadingSpinner.vue";

  // import { computed } from 'vue';
  // import { useRoute } from 'vue-router';

  // const route = useRoute();

  // const publicPages = ['Login', 'Logout'];
  // const isPublicPage = computed(() => route.name != null && route.name != '' && publicPages.includes(route.name.toString()));
</script>

<style lang="scss">
  @import './assets/sass/main.scss';
  @import '../node_modules/bootstrap/scss/bootstrap.scss';

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    background: rgb(242, 243, 248);
    min-height: 100vh;
    display: flex;
    width: 100% !important;
  }

  #main-content {
    height: 100%;
    background: rgb(242, 243, 248);
  }
</style>
